var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50aed57d352d5707dd940c88ae69ab98.js').default;export default
        Object.assign({}, scope_0 )
    